import axios from "axios"
import { rutas } from "../rutas/rutas"
import { getCookie } from "../utils/getCookies"

export const claimTorneo = async(id )=>{
   
        const token = getCookie('token')
         return axios({
            url: rutas.rewardTorneo,
            data: {id},
            method: 'post',
            headers:{
                token: token
            }
        })
    
       
 
}
  